<template>
    <div class="row">
        <div class="img-div">
            <img class="icon" src="../assets/images/success.png"/>
            <h4>Your password has been changed!</h4>
        </div>
        <p>Your new password may take a couple of hours to work
            across Autodesk sites and services.</p>
        <p>You can only reset your password every 24 hours.</p>
        <p>Your password will expire in 365 days.</p>

        <div>
            <div class="img-div">
                <img class="icon" src="../assets/images/warning.png"/>
                <h4>You won't be able to unlock your computer with the new
                    password. Use your old password until you connect to the
                    network.</h4>
            </div>

            <div class="img-div">
                <img class="icon" src="../assets/images/info.png"/>
                <h4>You should be able to log into your email, intranet,
                    and other services with your new password.</h4>
            </div>

            <div class="img-div">
                <img class="icon" src="../assets/images/cell.png"/>
                <h4>Use a smart phone or tablet at work?</h4>
            </div>

            <p >Follow any pop-ups on your device that may ask you to
                enter your new password. Ignoring these prompts can lock you out
                of the network.</p>
            <p >You can also change email, calendar, or wifi
                passwords within the device settings.</p>
        </div>

        <div class="col-12 text-center text-sm-center text-lg-right">
            <input class="btn flat-blue-btn go-home-btn" type="submit" v-bind:value="CONSTANTS.GO_HOME_OPTIONS" @click="navigateToHome"/>
        </div>

    </div>
</template>

<script>
    import * as CONSTANTS from "../store/constants";
    export default {
        name: 'ChangePasswordSuccess',
        data() {
            return {
                CONSTANTS
            }
        },
        computed: {
            domain() {
                return this.$store.state.domain;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h4 {
        font-size: 14px;
        font-weight: bolder;
        color: black;
        line-height: 21px;
        text-align: start;
    }
    p {
        font-size: 13px;
        margin: 0px 0px 10px 45px;
    }
    .img-div {
        display: flex;
        padding: 10px 5px 10px 5px;
    }
    .icon {
        width: 30px;
        height: 25px;
        margin-right: 10px;
    }
    .go-home-btn {
        margin-top: 10px;
    }
</style>
